import React, { Component } from 'react';
import PropTypes from 'prop-types';
import GDAccountNumberCell from 'Components/GDTable/GDAccountNumberCell/GDAccountNumberCell';
import GDDateCell from 'Components/GDTable/GDDateCell';
import GDCurrencyCodeCell from 'Components/GDTable/GDCurrencyCodeCell';
import CardType from 'Components/CardType';
import BVLoader20 from 'Components/loaders/BVLoader/BVLoader20';
import InformationBubble from 'Components/information-bubble/InformationBubble';
import {
  getCaseData,
  getCardBrandData,
  getAuthNewTabData,
  getTranNewTabData
} from 'Apis/caseAPI.js';
import { getUrlSearchParamValue } from 'Utils/urlUtils.js';
import ResponseBanner from 'Components/cards/ResponseBanner';
import { connect } from 'react-redux';
import { customFormatclass, customClassCurrency } from 'Components/GDTable/GDCustomFormat/GDCustomFormat';
import { Row, Col } from 'antd';
import GDColorCodedCell from '../GDTable/GDColorCodedCell/GDColorCodedCell';
import { getNewTabData } from 'Containers/CaseLanding/configStructure';
import { getFormattedSchemeData } from 'Utils/formatting.js';
import EmptyState from 'Components/EmptyState/EmptyState';
import ImagePortal from 'Containers/ImagePortal';
import './timelineDetailView.scss';

class timelineDetailView extends Component {
  constructor(props) {
    super(props);
    this.references = [];
    this.divHeightArray = [];
    this.state = {
      isLoading: true,
      dataErr: true,

      authData: undefined,
      tranData: undefined,
      schemeData: undefined,
      caseData: undefined,
    };
    this.getDetails = this.getDetails.bind(this);
    this.scrollToRef = this.scrollToRef.bind(this);
    this.renderResponseBanner = this.renderResponseBanner.bind(this);
  }

  componentWillMount() {
    this.getDetails(this.props.match.params.caseStageId);
  }

  renderResponseBanner() {
    const banner = { ...this.props.banner };
    return (
      <div>
      <ImagePortal>
        <ResponseBanner
          titleStyle={{ color: 'light-green' }}
          descriptionStyle={{ color: 'grey' }}
          valueStyle={{ color: 'black' }}
          title={banner.title}
          description={banner.description}
          type={banner.type}
          onClose={banner.closeNotification}
          cancel
          secondaryButtonText={banner.secondaryButtonText}
          primaryButtonText={banner.primaryButtonText}
          cancelButtonText={banner.cancelButtonText}
          isSecondaryButton
          isSecondaryButtonActive={banner.isSecondaryButtonActive}
          secondaryButtonAction={banner.secondaryButtonAction}
          primaryButtonAction={banner.primaryButtonAction}
          primaryButtonActionValue={banner.primaryButtonActionValue}
          cancelOnly={banner.cancelOnly}
          textField={banner.textField}
          timeLeft={banner.timeLeft}
          isDetokenize={banner.isDetokenize}
          descriptionHtml={banner.descriptionHtml}
        />
        </ImagePortal>
      </div>
    );
  }

  scrollToRef = (key) => {
    /// const keyArray = [1, 2, 3, 4];
    if (this.references && this.references.length !== 0) {
      let reference = this.references.filter(item => item.getAttribute('id') === key)
      window.scrollTo(0, reference[0].offsetTop);
      /*  for (let i = 0; i < 4; i++) {
         this.divHeightArray = this.divHeightArray.concat(this.references[i].offsetHeight);
       }
       for (let i = 0; i < 4; i++) {
         document.getElementById(keyArray[i]).setAttribute("style", `height:${Math.max(...this.divHeightArray)}px`)
       } */
      let list = document.getElementById(1);
      if (list.offsetHeight > 350) {
        for (let i = 0; i < 4; i++) {
         // if (i <= 1)
            list.getElementsByTagName("li")[i].setAttribute("style", `border-bottom: 1px solid #ddd`);
        //  else
         //   list.getElementsByTagName("li")[i].setAttribute("style", `border-bottom: none`);
        }
      }
    }
  }

  componentDidUpdate(prevProps) {
    const key = getUrlSearchParamValue(this.props.location.search, 'key');
    this.scrollToRef(key);
  }

  getCaseDrawerData(caseStageId) {
    getCaseData(caseStageId).then((apiResponse) => {
      this.setState({
        caseStageId: caseStageId,
        caseData: apiResponse.data,
        isLoading: false,
        dataErr: false,
      })
    }).catch((error) => {
      this.setState({ caseData: [], dataErr: true, isLoading: false });
      console.log('Error Occured while fetching case drawer data', error);
    });
  }

  getAuthDrawerData(caseStageId) {
    getAuthNewTabData(caseStageId).then((apiResponse) => {
      this.setState({
        caseStageId: caseStageId,
        authData: apiResponse.data,
        isLoading: false,
        dataErr: false,
      })
    }).catch((error) => {
      this.setState({ authData: [], dataErr: true, isLoading: false, });
      console.log('Error Occured while fetching case drawer data', error);
    });
  }

  getTranDrawerData(caseStageId) {
    getTranNewTabData(caseStageId).then((apiResponse) => {
      this.setState({
        caseStageId: caseStageId,
        tranData: apiResponse.data,
        isLoading: false,
        dataErr: false,
      })
    }).catch((error) => {
      this.setState({ tranData: [], dataErr: true, isLoading: false });
      console.log('Error Occured while fetching case drawer data', error);
    });
  }

  getSchemeDrawerData(caseStageId) {
    getCardBrandData(caseStageId).then((apiResponse) => {
      this.setState({
        caseStageId: caseStageId,
        schemeData: [].concat(getFormattedSchemeData(apiResponse.data)),
        isLoading: false,
        dataErr: false,
      })
    }).catch((error) => {
      this.setState({ schemeData: [], dataErr: true, isLoading: false });
      console.log('Error Occured while fetching case drawer data', error);
    });
  }

  getDetails(caseStageId) {
    this.getCaseDrawerData(caseStageId);
    this.getSchemeDrawerData(caseStageId);
    this.getAuthDrawerData(caseStageId);
    this.getTranDrawerData(caseStageId);
  }

  getItemData = (item, index, data) => {
    const key = `${index} ${item.columnKey}`;
    if (data[`${item.columnKey}`] !== null && data[`${item.columnKey}`] !== undefined && `${data[`${item.columnKey}`]}`.trim() !== '') {
      if (item.displayType === 'DATE') {
        return (
          <span className="date">
            <GDDateCell
              key={`${item.columnKey}`}
              date={data[`${item.columnKey}`]}
              dateFormat={{}.dateFormat}
              timeFormat={{}.timeFormat}
            />
          </span>
        );
      }
      if (item.displayType === 'MERCHANTNUMBER') {
        return (
          <div className="gd-color-coded-cell">
            <GDColorCodedCell
              key={key}
              content={data[item.columnKey]}
            />
          </div>
        );
      }
      if (item.displayType === 'HIERARCHY') {
        return (
          <span>
            {`${data.merchantDetail_corporate}-${data.merchantDetail_region}-${
              data.merchantDetail_principal}-${data.merchantDetail_associate}-${
              data.merchantDetail_chain}`}
          </span>
        );
      }
      if (item.displayType === 'LONGSTRING') {
        return <span>{data[`${item.columnKey}`]}</span>;
      }
      if (item.displayType === 'MAILINGADDRESS') {
        return (
          <span>
            {data[`${item.columnKey}`]}

          </span>
        );
      }
      if (item.displayType === 'ACCOUNTNUMBER') {
        return (
          <GDAccountNumberCell
            accountNumber={data[`${item.columnKey}`]}
            token={data[item.secondaryColumnKey]}
          />
        );
      }
      if (item.displayType === 'CURRENCY_UNIT') {
        return (
          <span className="currency-cell">{this.handlePrecision(data[`${item.columnKey}`], 2 )}</span>
        );
      }
      else if (item.displayType === 'card_type') {
        return (
          <div className="card-type">
            <CardType
              abbreviation={data[`${item.columnKey}`].toUpperCase()}
              type={data[item.columnKey].toUpperCase()}
            />
          </div>
        );
      }
      else {
        return <span>{data[`${item.columnKey}`]}</span>;
      }
    } else if (typeof item.columnKey === 'object') {
      if (item.displayType === 'CARDTYPE_ACCOUNTNUMBER' && data[`${item.columnKey.value2}`]) {
        return (
          <div>
            <div className="card-type">
              <CardType
                abbreviation={data[`${item.columnKey.value1}`]}
                type={data[item.columnKey.value1]}
              />
            </div>
            <div className="overviewpane-account-cell">
              <GDAccountNumberCell
                accountNumber={data[`${item.columnKey.value2}`]}
              />
            </div>
          </div>
        );
      } else if (item.displayType === 'DATE_AMOUNT' && data[`${item.columnKey.value1}`] != null) {
        return (
          <div>
            <span className="date-cell">
              <GDDateCell
                key={`${item.columnKey.value1}`}
                date={data[`${item.columnKey.value1}`]}
                dateFormat={{}.dateFormat}
                timeFormat={{}.timeFormat}
              />
            </span>
            <span className="currency-cell">{this.handlePrecision(data[item.columnKey.value1], 2 )}</span>
          </div>
        );
      } else if (item.displayType === 'STRING_STRING') {
        return (
          <div>
            <span style={{ paddingRight: '30px' }}>{data[`${item.columnKey.value1}`]}</span>
            <span style={{ paddingLeft: '30px' }}>{data[`${item.columnKey.value2}`] ? data[`${item.columnKey.value2}`] : '--'}</span>
          </div>
        );
      } else if (item.displayType === 'ADDRESS') {
        return (
          <div>
            <span>{data[`${item.columnKey.value1}`]}</span>
            <br />
            <span>{data[`${item.columnKey.value2}`]}</span>
          </div>
        );
      }
      if (item.displayType === 'CURRENCY_UNIT') {
        return (
          <span className="currency-cell">{this.handlePrecision(data[item.columnKey.value1], 2 )}</span>
        );
      }
    }
    return <span>--</span>;
  };

 handlePrecision = (amount, precision) => {
    if (amount !== undefined && amount !== null) {
      const arr = `${amount}`.split('.');
      return arr.length > 1
        ? `${arr[0] <= 0 ? arr[0] * -1 : arr[0]}.${arr[1].length === 1 ? `${arr[1]}0` : arr[1].substr(0, precision)}`
        : `${amount <= 0 ? amount * -1 : amount}.00`;
    }
    return '--';
  };

  getCurrencyCell = (amount, currency, columnKey1, columnKey2) => {
    if (currency !== undefined) {
      const normalizedValue = amount === 0 ? 0 : amount || '--';
      const normalizedUnits = currency || '';
      let valueClass;
      if (Number.isNaN(Number.parseFloat(amount))) {
        return <span key={`${columnKey1}`}>{normalizedValue}</span>;
      }

      if (!Number.isNaN(Number.parseFloat(normalizedValue)) && Number.parseFloat(normalizedValue) < 0) { valueClass = customFormatclass(customClassCurrency, item.displayType); }
      return (
        <GDCurrencyCodeCell
          key={`${columnKey1}`}
          value={normalizedValue}
          units={normalizedUnits}
          customClass={valueClass}
        />
      );
    } else {
      let valueClass;
      const normalizedValue = amount !== '' ? amount : '--';
      if (!Number.isNaN(Number.parseFloat(normalizedValue)) && Number.parseFloat(normalizedValue) < 0) { valueClass = customFormatclass(customClassCurrency, item.displayType); }
      return (
        <GDCurrencyCodeCell
          key={`${columnKey1}`}
          value={normalizedValue}
          customClass={valueClass}
        />
      );
    }
  };

  getCurrencyCell = (amount, currency, columnKey1, columnKey2) => {
    if (currency !== undefined) {
      const normalizedValue = amount == 0 ? 0 : amount || '--';
      const normalizedUnits = currency || '';
      let valueClass;
      if (Number.isNaN(Number.parseFloat(amount))) {
        return <span key={`${columnKey1}`}>{normalizedValue}</span>;
      }

      if (!Number.isNaN(Number.parseFloat(normalizedValue)) && Number.parseFloat(normalizedValue) < 0) { valueClass = customFormatclass(customClassCurrency, item.displayType); }
      return (
        <GDCurrencyCodeCell
          key={`${columnKey1}`}
          value={normalizedValue}
          units={normalizedUnits}
          customClass={valueClass}
        />
      );
    } else {
      let valueClass;
      const normalizedValue = amount !== '' ? amount : '--';
      if (!Number.isNaN(Number.parseFloat(normalizedValue)) && Number.parseFloat(normalizedValue) < 0) { valueClass = customFormatclass(customClassCurrency, item.displayType); }
      return (
        <GDCurrencyCodeCell
          key={`${columnKey1}`}
          value={normalizedValue}
          customClass={valueClass}
        />
      );
    }
  };

  render() {
    const { authData, tranData, schemeData, caseData, } = this.state;

    if (authData !== undefined && tranData !== undefined && schemeData !== undefined && caseData !== undefined) {

      const dataList = { authData, tranData, schemeData, caseData, };
      let configStructure = [];
      for (let key of Object.keys(dataList)) {
        dataList[key].forEach(dataItems => {

          configStructure = configStructure.concat({ ...getNewTabData(key, dataItems), dataItems: dataItems });
        });
      }

      return (
        <React.Fragment>
          {this.props.notification.show === true && this.renderResponseBanner()}
          {this.state.isLoading && <BVLoader20 />}
          <div className="page-wrapper">
            {!this.state.isLoading &&
              configStructure.map((element, index1) => {
                return (
                  <div className={index1 === 2 ? 'open-newtab add-margin' : 'open-newtab'} id={element.id} ref={(element) => (this.references[index1] = element)} key={index1}>
                    <div className="open-newtab-title" id="title">
                      <Row>
                        <Col span={23}><h2 className="titleContent">{element.title}</h2></Col>
                      </Row>
                    </div>
                    <ul className="open-newtab-list">
                      {
                        element.dataColumns?.sort((ele1, ele2) => {
                          const item1 = ele1.name.toLowerCase();
                          const item2 = ele2.name.toLowerCase();
                          if (item1 < item2) return -1;
                          if (item1 > item2) return 1;
                          return 0;
                        }).map((item, index2) => {
                          return (
                            <li className={item.displayType === 'TABLE' ? "open-newtab-list-item" : "show-border open-newtab-list-item"} key={item.name}>
                              <div className="open-newtab-list-item-wrapper">
                                <span className="open-newtab-list-item-label">
                                  {item.name}
                                </span>
                                <span className={item.displayType === 'LONGSTRING' && dataList[`${item.columnKey}`] && dataList[`${item.columnKey}`].length > 27 ? 'long-string' : 'overviewpane-list-item-content'}>
                                  {this.getItemData(item, index2, element.dataItems)}
                                  <span className="reason-code-tooltip">
                                    {
                                      item.displayType == 'RC' && (
                                        <InformationBubble
                                          id={item.descriptionKey}
                                          info
                                        />
                                      )
                                    }
                                  </span>
                                </span>
                              </div>
                            </li>
                          );
                        })
                      }
                    </ul>
                  </div>
                );
              })
            }
          </div>
        </React.Fragment>
      );
    } 
    if(authData === [] && tranData === [] && schemeData === [] && caseData === []) {
      <EmptyState
      translations={{ emptyStateHeading: this.state.emptyStateHeading, emptyStateDescription: this.state.emptyStateDescription }}
    />
    }
    else {
      return <BVLoader20 />
    }
  }
}

const mapStateToProps = (state) => ({
  banner: state.notification.banner[0],
  notification: state.notification,
});


const mapDispatchToProps = (dispatch) => {
  return {
    setNotification: (banner) => dispatch(successNotificationBanner(banner)),
    closeNotification: () => dispatch(closeNotificationBanner()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(timelineDetailView);